import { ERROR_CODES } from '~/authentication/lib/errors';
import classifyAuthError, {
	AUTH_ERROR_CLASS,
	isRoleRejection
} from '~/authentication/lib/classifyAuthError';
// --- internal imports ------

const CONTACT_HR = 'Please contact your HR manager.';

// Keyed by the code the user system sends. A player only ever sees one of these
// after the request has already failed, so every message names what went wrong
// and who can undo it — none of them are worth a retry.
const COPY_BY_CODE = {
	[ERROR_CODES.USER_SYSTEM.LICENSE_EXPIRED]: {
		header: 'License Expired',
		message: `Your license has expired, so you can not enter the game right \
now. ${CONTACT_HR}`
	},
	[ERROR_CODES.USER_SYSTEM.INVALID_LICENSE]: {
		header: 'License Issue',
		message: `The license on your account is no longer valid. ${CONTACT_HR}`
	},
	[ERROR_CODES.USER_SYSTEM.NO_LICENSE]: {
		header: 'No License',
		message: `There is no license assigned to your account yet. ${CONTACT_HR}`
	},
	[ERROR_CODES.USER_SYSTEM.ACCOUNT_REVOKED]: {
		header: 'Account Revoked',
		message: 'This account has been revoked. Please contact your administrator.'
	},
	[ERROR_CODES.USER_SYSTEM.ACCOUNT_NOT_FOUND]: {
		header: 'No Account',
		message: `We could not find an account for this e-mail address. Please \
check the address you used, or contact your HR manager.`
	}
};

// A role rejection is thrown before the guard chain attaches any code, so it
// arrives as a bare 403 and is matched on its status instead — by the same
// helper the classification uses, so the two cannot drift apart.
const ROLE_COPY = {
	header: 'Wrong Portal',
	message: `This account is not a player account, so it can not be used to play \
the game. Please sign in through the HR portal instead.`
};

const TRANSIENT_COPY = {
	header: 'No Connection',
	message: `We could not reach the server. Your account is fine — please try \
again in a moment.`
};

const FALLBACK_COPY = {
	header: 'Sign In Failed',
	message: `We could not sign you in. Please try again, and contact your HR \
manager if this keeps happening.`
};

export function resolveAuthErrorCopy(error) {
	const copyForCode = COPY_BY_CODE[error?.code];
	if (copyForCode) {
		return copyForCode;
	}

	if (isRoleRejection(error)) {
		return ROLE_COPY;
	}

	if (classifyAuthError(error) === AUTH_ERROR_CLASS.TRANSIENT) {
		return TRANSIENT_COPY;
	}

	return FALLBACK_COPY;
}

export default resolveAuthErrorCopy;
